
import { getRoomIdentifyQuantity, updateRoomIdentifyQuantity } from '@/api/room-manage';
import { dangerLevel, iDangerLevelModel } from '@/interface/room-manage';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  filters: {
    levelLabel(level: number) {
      let str: string = '';
      switch (level) {
        case dangerLevel.WARNING:
          str = '警告';
          break;
        case dangerLevel.MUTED:
          str = '禁言';
          break;
        case dangerLevel.CLOSED:
          str = '关闭房间';
          break;
        default:
          str = '其他';
      }
      return str;
    },
  },
})
export default class extends Vue {
  @Prop({ default: false }) show!: boolean;

  private form = {
    levels: [
      {
        danger_level: dangerLevel.WARNING,
        total_reject: '',
        politics: '',
        porn: '',
        ban: '',
        violence: '',
      },
      {
        danger_level: dangerLevel.MUTED,
        total_reject: '',
        politics: '',
        porn: '',
        ban: '',
        violence: '',
      },
      {
        danger_level: dangerLevel.CLOSED,
        total_reject: '',
        politics: '',
        porn: '',
        ban: '',
        violence: '',
      },
    ],
  };

  validateCheck() {
    let validated: boolean = true;
    this.form.levels.forEach((level: iDangerLevelModel) => {
      if (level.total_reject < level.politics || level.total_reject < level.porn || level.total_reject < level.ban || level.total_reject < level.violence) {
        validated = false;
      }
    });
    return validated;
  }

  async handleSubmit() {
    if (!this.validateCheck()) {
      return this.$message.error('总reject数需要大于各个分支类别数量');
    }
    const resp = await updateRoomIdentifyQuantity(this.form.levels);
    if (!resp.code) {
      this.$message.success('告警配置更新成功');
      this.handleClose();
    } else {
      this.$message.error(resp.msg);
    }
  }

  handleClose() {
    this.$emit('close');
  }

  async getConfig() {
    const { data } = await getRoomIdentifyQuantity({});
    this.form.levels = data;
  }

  created() {
    this.getConfig();
  }
}
